import { InitializerExecutor } from '@wajeez-web/core/types';
import { NavigationActions } from '@wajeez-web/stores/common';
import { MdProductionQuantityLimits } from 'react-icons/md';
import ModifyPolicyPage from './Pages/ModifyPolicyPage';
import PoliciesPage from './Pages/PoliciesPage';
import { PoliciesCrump } from './components/PoliciesCrump';
import FaqsPage from './Pages/FaqsPage';
import PromoCodeAliasesPage from './Pages/PromoCodeAliasesPage';
import ProductsPage from './Pages/ProductsPage';
import ProductGroupsPage from './Pages/ProductGroupsPage';
import PromoCodesPage from './Pages/PromoCodesPage';
export const initializeProductsRoutes: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateRoutes([
      {
        name: 'Product',
        href: '/product',
        per: ['47.0', '78.0', '116.4', '4.16', '62.10', '63.4'],
        icon: MdProductionQuantityLimits,
        children: [
          {
            name: 'Policies',
            href: '/policies',
            per: ['47.0'],
          },
          {
            name: 'FAQs',
            href: '/faqs',
            per: ['78.0'],
          },
          {
            name: 'Promo Code Aliases',
            href: '/promocode-aliases',
            per: ['116.4'],
          },
          {
            name: 'Products',
            href: '/products',
            per: ['4.16'],
          },
          {
            name: 'Product Groups',
            href: '/product-groups',
            per: ['62.10'],
          },
          {
            name: 'Promo Codes',
            href: '/promocodes',
            per: ['63.4'],
          },
        ],
      },
    ])
  );
};

export const initializeProductsEndpoints: InitializerExecutor = async (
  dispatch
) => {
  dispatch(
    NavigationActions.updateEndpoints([
      {
        type: 'container',
        endpoint: 'policies',
        crump: 'policies',
        per: ['47.0'],
        children: [
          {
            type: 'endpoint',
            crump: 'new',
            endpoint: 'create',
            component: ModifyPolicyPage,
            per: [],
          },
          {
            type: 'endpoint',
            endpoint: ':id',
            crump: PoliciesCrump,
            component: ModifyPolicyPage,
            per: [],
          },
          {
            type: 'endpoint',
            endpoint: '',
            component: PoliciesPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'faqs',
        crump: 'faqs',
        per: ['78.0'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: FaqsPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'promocode-aliases',
        crump: 'Promo Code Aliases',
        per: ['116.4'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: PromoCodeAliasesPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'products',
        crump: 'Products',
        per: ['4.16'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: ProductsPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'product-groups',
        crump: 'Product Groups',
        per: ['62.10'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: ProductGroupsPage,
            per: [],
          },
        ],
      },
      {
        type: 'container',
        endpoint: 'promocodes',
        crump: 'Promo Codes',
        per: ['63.4'],
        children: [
          {
            type: 'endpoint',
            endpoint: '',
            component: PromoCodesPage,
            per: [],
          },
        ],
      },
    ])
  );
};
